"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OverlayPortal;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _layers = require("@site/pattern-library-utils/layers");
var _useEntryExitAnimation = require("../../hooks/use-entry-exit-animation");
/**
 * OverlayPortal
 *
 * @param {Object} props React props
 * @param {boolean} props.open Whether the overlay is open
 * @param {number} [props.duration=200] Animation duration in ms
 * @param {string} [props.className] Optional class name
 * @param {Object} [props.style] Optional inline styles
 * @param {number} [props.zIndex] Overlay z-index
 * @param {Function} [props.onClick] Click handler when visible
 * @param {any} [props.container] Optional portal container (defaults to document.body)
 * @returns {React.ReactElement|null} Overlay element or null when not mounted/SSR
 */
function OverlayPortal({
  open,
  duration = 200,
  className,
  style,
  zIndex = _layers.knownZIndexes.overlay,
  onClick,
  container
}) {
  const animation = (0, _useEntryExitAnimation.useEntryExitAnimation)(Boolean(open), duration);
  const target = typeof document !== 'undefined' ? container || document.body : null;
  if (!animation.isMounted || !target) {
    return null;
  }
  return /*#__PURE__*/_reactDom.default.createPortal(/*#__PURE__*/_react.default.createElement("div", {
    className: className,
    "data-cy": "educational-dropdown-overlay",
    style: {
      ...animation.fadeStyle,
      zIndex,
      ...style
    },
    onClick: animation.isVisible ? onClick : null,
    "aria-hidden": "true"
  }), target);
}
OverlayPortal.propTypes = {
  open: _propTypes.default.bool,
  duration: _propTypes.default.number,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  zIndex: _propTypes.default.number,
  onClick: _propTypes.default.func,
  container: _propTypes.default.any
};